import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-local-invoice',
  templateUrl: './local-invoice.component.html',
  styleUrls: ['./local-invoice.component.scss']
})
export class LocalInvoiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
